module.exports = __webpack_public_path__ + "assets/img/paddle_leash.dd61a539.png";